<template>
  <v-list-tile v-if="list" :to="route" target="_blank">
    <v-list-tile-action>
      <v-icon color="primary" class="theme--light">edit</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      {{ $t('message.metadata.entityEditor') }}
    </v-list-tile-content>
  </v-list-tile>
  <v-tooltip top v-else>
    <template #activator="{on}">
      <v-btn v-if="captureClick" v-on="on" class="ma-0" icon @click.capture.stop="openUrl" :to="route">
        <v-icon color="primary" class="theme--light">edit</v-icon>
      </v-btn>
      <v-btn v-else class="ma-0" icon :to="route">
        <v-icon color="primary" class="theme--light">edit</v-icon>
      </v-btn>
    </template>
    <strong v-html="$t('message.metadata.entityEditor')"></strong>
  </v-tooltip>
</template>

<script>
export default {
  name: 'nx-list-action-entity-editor',
  props: {
    id: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    list: {
      type: Boolean,
    },
    captureClick: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // se usa un método para abrir el link porque este componente se usa
    // dentro de un slot que tiene el evento @click.capture.stop para evitar
    // que al interactuar con las acciones se abra el link del elemento del listado
    // que contiene estas acciones. Al hacer esto el link no se abre si se intenta
    // de la manera convencional ie :href blabla
    openUrl() {
      this.$router.push(this.route);
    },
  },
  computed: {
    route() {
      if (this.type === 'board') {
        return { name: 'board.editor', params: { id: this.id } };
      }
      return { name: 'entity.editor', params: { id: this.id, entity: this.type, tab: 'editor' } };
    },
  },
};
</script>
